const customListItemActions: Map<string, object> = new Map();

export function getCustomListItemActionComponentForType(type: string) {
  return customListItemActions.get(type);
}
export function registerCustomListItemActionComponent(type: string, component: object) {
  customListItemActions.set(type, component);
}
